import React, { useState } from "react";
import { Configure } from "react-instantsearch";

const AlphabetFilter = () => {
  const [activeLetter, setActiveLetter] = useState("");
  const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
  return (
    <div className="flex items-center justify-between px-6 md:px-6 text-13 text-pl_txt_light_2 dark:text-pl_txt_dark_1 font-normal dark:font-light max-w-[800px] w-full">
      <Configure
        hitsPerPage={10}
        filters={activeLetter ? `starting_letter:${activeLetter}` : ""}
      />
      {alphabet.map((alphabet) => (
        <div
          key={alphabet}
          className={`whitespace-nowrap py-1 px-0 border-none flex items-center justify-center text-13 font-normal ${
            activeLetter === alphabet
              ? "font-semibold border-b-2 dark:border-pl_txt_dark_1 text-pl_prim_color_1 "
              : "bg-pl_bg_light_3 dark:bg-pl_bg_dark_3 text-pl_txt_light_1 dark:text-pl_txt_dark_1 border border-pl_border_light_1 dark:border-pl_border_dark_1"
          }`}
          onClick={() => {
            setActiveLetter(alphabet);
          }}
          aria-label={`Filter by letter ${alphabet}`}
          aria-pressed={activeLetter === alphabet}
          style={{ cursor: "pointer" }}
        >
          {alphabet}
        </div>
      ))}
      <button
        className={`whitespace-nowrap py-1 px-0 border-none flex items-center justify-center text-13 font-normal ${
          activeLetter === ""
            ? " text-pl_prim_color_1 font-semibold dark:border-pl_txt_dark_1"
            : "bg-pl_bg_light_3 dark:bg-pl_bg_dark_3 text-pl_txt_light_1 dark:text-pl_txt_dark_1 border border-pl_border_light_1 dark:border-pl_border_dark_1"
        }`}
        onClick={() => setActiveLetter("")}
      >
        All
      </button>
    </div>
  );
};
export default AlphabetFilter;
